import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import Header from "./../include/Header";
import Apihelpers from './../helper/ApiHelper';

//import {GET_MASTER_SERVICE_LIST } from './../helper/Constants';


class SourceComment extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sourceid:this.props.match.params.sourceid,
      sourceInfo:{},
      loader: false,
      listData:[],
      cmtLimit:5,
      hideShowAll: false,
      createRecord: {
        source_comment: "",
        source_username: "",
        doc: "",
      },
    }
  }

  componentDidMount() {
    this.loadSource();
    this.getSourceCommentList();
  }


  loadSource = () => {
    let parmes = '?id='+this.state.sourceid;
    this.setState({loader: true });
    Apihelpers.getdataresponse('allsources/get-source'+parmes).then(res => {
      //console.log('res.data',res.data);
      if (res.data.status === true) {
        let data = res.data.data;
        console.log('data',data);
        this.setState({
          sourceInfo:data,
        })
      }
      this.setState({loader: false });
    });
  }
  getSourceCommentList = () => {
    let parmes = '?id='+this.state.sourceid+'&skip=0&limit='+this.state.cmtLimit;
    this.setState({loader: true });
    Apihelpers.getdataresponse('allsources/get-source-comments'+parmes).then(res => {
      //console.log('res.data',res.data);
      if (res.data.status === true) {
        let data = res.data.data.record;
        console.log('data',data);
        this.setState({
          listData:data,
        })
        if(res.data.data.totalCount < 6) {
          this.setState({
            hideShowAll:true
          })
        }
      }
      this.setState({loader: false });
    });
  }

  formSubmitFun = (e) => {
    e.preventDefault();
    if(this.state.createRecord.doc !== '') {
      let extension = this.state.createRecord.doc.name.replace(/^.*\./, '').toLowerCase();
      console.log('extension',extension);
      if(extension === "pdf" || extension === "jpg" || extension === "jpeg" || extension === "png") {
        console.log('file is ok');
      } else {
        alert('Please add valid pdf file');
        return;
      }
    }
    const formData = new FormData();
    formData.append("source_id", this.state.sourceid);
    formData.append("comment_by", this.state.createRecord.source_username);
    formData.append("comment", this.state.createRecord.source_comment);
    if(this.state.createRecord.doc !== '') {
      formData.append("attach_file", this.state.createRecord.doc);
    }

    console.log('call api....',[...formData]);
    //return;
    this.setState({loader:true});
    Apihelpers.postdataresponseMultipart('allsources/source-comment-add', formData)
      .then((res) => {
        console.log('res', res.data);
        if (res.data.status === true) {
          //add reload
          document.getElementById("create-cmt-form").reset();
          this.getSourceCommentList();
        } else {
          console.log('coming validation error');
        }
        this.setState({loader:false});
      }).catch((error) => {
        console.log('error', error);
      });
  }


  render() {
    return (
      <div className="wrapper">
        <Header />
        <div className="container">
          <div className="sourceComentPage whiteBox">
            {
              //JSON.stringify(this.state.listData,null,2)
            }
            <div className="titleRow">
              <div className="row align-items-center">
                <div className="col">
                  <h3 className="title">Vendor Name: <span className="blue-txt">{this.state.sourceInfo.vendor_name}</span> </h3>
                </div>
                <div className="col-auto">
                  <NavLink to={"/admin/source-list"}><i className="fa fa-arrow-left"></i> Back to Source List</NavLink>
                </div>
              </div>
            </div>
            <div className="addSourceCommentBlock">
              <form id="create-cmt-form" className="form" method="post" onSubmit={this.formSubmitFun}>
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label className="control-title">Comment Add By <span className="ex">*</span></label>
                      <input className="form-control" type="text" placeholder="enter name" required onChange={(e) => {
                      this.setState({ createRecord: { ...this.state.createRecord, "source_username": e.target.value } })
                    }} />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label className="control-title">Attach File </label>
                      <input type="file" className="form-control" onChange={(e) => {
                      this.setState({ createRecord: { ...this.state.createRecord, "doc": e.target.files[0] } })
                    }} accept="image/jpg,image/jpeg,image/png,application/pdf" />
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="form-group">
                      <label className="control-title">Comment <span className="ex">*</span></label>
                      <textarea className="form-control" placeholder="enter comment" required onChange={(e) => {
                        let text = e.target.value;
                      this.setState({ createRecord: { ...this.state.createRecord, "source_comment": text.charAt(0).toUpperCase() + text.slice(1) } })
                    }} value={this.state.createRecord.source_comment} minLength="10" maxLength="300"></textarea>
                    </div>
                  </div>
                </div>
                <div className="btnRow">
                  <button type="reset" className="backBtn">Cancel</button>
                  <button type="submit" className="blueBtn">Add Comment</button>
                </div>
              </form>
            </div>
            <div className="sourceCommentListBlock">
              <h3>Comment List</h3>
              <ul className="commentList">
                {
                  (this.state.listData.length > 0) ?
                    <>
                      {
                        this.state.listData.map((cmt)=>{
                          return(
                            <li key={cmt._id}>
                               <div className="cmtText">{cmt.comment}</div>
                               <div className="otherInfo">
                                  <span className="aa">Comment By: <strong>{cmt.comment_by}</strong></span>
                                  <span className="aa">Added on: <strong>{cmt.createdAt}</strong></span>
                                  {
                                    (cmt.attach_file !== undefined) ?
                                    <span className="aa">Attachment: <button className="btn-icon" type="button" onClick={()=>{
                                      window.open(Apihelpers.getBaseUrl()+'source_documents/'+cmt.attach_file, '_blank');
                                    }}><i className="fa fa-eye"></i></button></span>
                                    :""
                                  }
                                </div>
                            </li>
                          )
                        })
                      }
                    </>
                  :
                  <li><div className="cmtText">Comment not added. </div></li>
                }
                {/* <li>
                  <div className="cmtText">Lorem ipsum, or lipsum as it is sometimes known, is dummy text used in laying out print, graphic or web designs. The passage is attributed to an unknown typesetter in the 15th century who is thought to have scrambled parts of Cicero's De Finibus Bonorum et Malorum for use in a type specimen book.</div>
                  <div className="otherInfo">
                    <span className="aa">Comment By: <strong>Dipesh Narkar</strong></span>
                    <span className="aa">Added on: <strong>17-04-2025</strong></span>
                    <span className="aa">Attachment: <i className="fa fa-eye"></i></span>
                  </div>
                </li> */}
              </ul>
              {
                (this.state.hideShowAll === false) ?
                  <div className="loadMore"><span onClick={()=>{
                    this.setState({cmtLimit:50,hideShowAll:true},()=>{
                      this.getSourceCommentList();
                    });
                  }}>Show All</span></div>
                :""
              }
            </div>
          </div>
        </div>

        <div className="loader" style={{ display: `${this.state.loader ? 'block' : 'none'}`, zIndex:'111'}}>
          <div className="bg" />
          <img className="loadingImg" src="/assets/images/loading.gif"  alt="" />
        </div>
      </div>
    )
  }
}

export default SourceComment;